import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useFlags } from 'launchdarkly-react-client-sdk';

// Components
import { WpButton } from 'Wpds/components/button';
import ConnectMetaWorkplaceModal from 'Dashboard/components/ConnectMetaWorkplaceModal/ConnectMetaWorkplaceModal';
import { WpContainer, WpContainerBody, WpContainerHeader } from 'Wpds/components/container';

// Hooks
import { useToggle } from 'Shared/utils/hooks';

// Actions
import { getNotificationDestinations } from 'Shared/actions/notifications';

// Styles
import './MetaWorkplaceSetup.scss';

const MetaWorkplaceSetup = () => {
  const metaWorkplaceNotificationDestination = useSelector(state =>
    state.notification_destinations.find(({ slug }) => slug === 'meta_workplace')
  );

  const { featureFlagMetaWorkplaceIntegration } = useFlags();

  const [isLoading, toggleIsLoading] = useToggle(false);
  const dispatch = useDispatch();

  useEffect(() => {
    toggleIsLoading();
    dispatch(getNotificationDestinations()).finally(() => {
      toggleIsLoading();
    });
  }, []);

  const [isOrgConnectModalOpen, toggleIsOrgConnectModalOpen] = useToggle(false);

  if (isLoading || !featureFlagMetaWorkplaceIntegration || !metaWorkplaceNotificationDestination) return null;

  const organization_notification_destination_connected =
    metaWorkplaceNotificationDestination.organization_notification_destination_connected;

  return (
    <div className="meta-workplace-setup">
      <WpContainer>
        <WpContainerHeader>
          <h5>Meta Workplace Setup</h5>
        </WpContainerHeader>
        <WpContainerBody>
          <div className="d-flex flex-column mb-3">
            <WpButton color="gray" variant="secondary" onClick={toggleIsOrgConnectModalOpen} size="sm">
              {organization_notification_destination_connected ? 'Update' : 'Enter'} credentials
            </WpButton>
            <ConnectMetaWorkplaceModal isOpen={isOrgConnectModalOpen} toggleIsOpen={toggleIsOrgConnectModalOpen} />
          </div>
        </WpContainerBody>
      </WpContainer>
    </div>
  );
};

export default MetaWorkplaceSetup;
